export default "__VITE_ASSET__a70b0430__"